import { render, staticRenderFns } from "./RecordPrimaryFilterLabel.vue?vue&type=template&id=1fee075a&"
import script from "./RecordPrimaryFilterLabel.vue?vue&type=script&lang=js&"
export * from "./RecordPrimaryFilterLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports